import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import { useDispatch, useSelector } from 'dva';
import React, { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import Loading from '@/components/Loading';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { tvfMathTypeMap, tvfRuleTypeMap } from '@/constants.js';
import ModalML from '@/components/modal_ml/ModalML';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';
import AddFieldPackage from '../../../../../_comm/containers/filter_field_package/index';
import Cascader from '@/containers/cascader_ml/cascader_package_ml/CascaderPackage';

const RuleTabel = (props) => {
  const dispatch = useDispatch();
  const { name, fetchData, form, saveLoading } = props || {};
  const { editable } = props.location.query;

  //控制弹框的开关
  const trigger = useTrigger();
  const deleteTrigger = useTrigger();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['tvfCondition/getTvfRuleList'];
  const delLoading = loadingEffect.effects['tvfCondition/deleteTvfRuleList'];
  const data = useSelector((state) => state.tvfCondition.getTvfRuleList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ruleList = data instanceof Array ? data : [];
  // const [delLoading, setDelLoading] = useState(false);
  const [tabelD, setTabelD] = useState([]);
  const [cascaderData, setCascaderData] = useState({});
  const [addOptions, setAddOptions] = useState([]);

  //删除规则
  const deleteRuleChange = (values) => {
    const { id: ids = '' } = values || {};
    if (String(ids).indexOf('null') !== -1) {
      const s = tabelD.filter((item) => item.id !== ids);
      setTabelD(s);
    } else {
      // setDelLoading(true);
      dispatch({
        type: 'tvfCondition/deleteTvfRuleList',
        payload: {
          values: {
            ...values,
          },
        },
        callback: (d) => {
          // setDelLoading(false);
          if (d) {
            message.warning(d.message);
          } else {
            message.success('删除成功');
          }
          fetchData();
        },
      });
    }
  };
  // let i = 0;
  const addRuleList = () => {
    let isAlreadyAdd =
      tabelD.filter((item) => String(item.id).includes('null')) || [];
    if (isAlreadyAdd.length) {
      message.warning('请点击保存，一条一条填写'); //多条一起填写增加删除会有每次清空的bug
      return;
    }
    setTabelD([...tabelD, { id: 'null0' }]);
    // dispatch({
    //   type: 'tvfCondition/addTvfRuleList',
    //   payload: {
    //     values: {
    //       fieldId: id,
    //     },
    //   },
    //   callback: () => {
    //     fetchData();
    //   },
    // });
  };

  //动态option组别1，2
  const groupOption = (num) => {
    const idArrs = (tabelD || [])
      .filter((item) => !String(item.id).includes('null'))
      .map((item) => item.id);
    let option = {};
    for (let i = 0; i < idArrs.length; i++) {
      if (!(idArrs[i] >= num)) {
        option[idArrs[i]] = '组别' + idArrs[i];
      }
    }
    return option;
  };
  //改变数组是时候更改是否可以选中状态(更改请求到的数据)
  const onSelectType = async (val, record, i) => {
    let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    (tabelDCopy || []).forEach((item, index) => {
      if (val === 'TEMPORARY') {
        if (record.id === tabelDCopy[0].id && index === 0) {
          message.warning('第一组不能选择组别');
          return;
        }
      }
      if (item.id === record.id && i === '1') {
        item.variableType1 = val;
        item.element1Name = undefined;
      } else if (item.id === record.id && i === '2') {
        item.variableType2 = val;
        item.element2Name = undefined;
      }
    });
    await setTabelD(tabelDCopy);
    let obj = {};
    if (i === '1') {
      obj['element1-' + record.id] = undefined;
      obj['element1@-' + record.id] = undefined;
    }
    if (i === '2') {
      obj['element2-' + record.id] = undefined;
      obj['element2@-' + record.id] = undefined;
    }
    form.setFieldsValue({
      ...obj,
    });
  };

  const changeOptions = () => {
    // const { fieldName, id: ids } = list && list.length ? list[0] : {};
    // let tabelDCopy = JSON.parse(JSON.stringify(tabelD));
    // //只能选一个，因为如果选多个的话就要挂载在每个table上，挂载一个选择数组。目前仅支持单个挂载
    // (tabelDCopy || []).forEach((item) => {
    //   if (item.id === curentRecord) {
    //     item['element' + curentFirst] = ids;
    //     item['element' + curentFirst + 'Name'] = fieldName;
    //   }
    // });
    // setTabelD(tabelDCopy);
  };
  const fetchTabelData = useCallback(() => {
    let s = ruleList ? ruleList : [];
    setTabelD([...s]);
  }, [ruleList]);
  useEffect(() => {
    fetchTabelData();
  }, [fetchTabelData]);

  // 对新增的并未保存的dataSouece进行清空
  useEffect(() => {
    let formResetObj = form.getFieldsValue();
    let newResetObj = {};
    for (let key in formResetObj) {
      if (key.includes('null')) {
        newResetObj[key] = undefined;
      }
    }
    form.setFieldsValue({
      ...newResetObj,
    });
  }, [tabelD.length]);

  // 刷新时候对form进行级联返现值
  useEffect(() => {
    let obj = {};
    tabelD.forEach((item) => {
      if (item.variableType1 === 'SYSTEM') {
        obj['element1@-' + item.id] = cascaderData[item.element1];
      }
      if (item.variableType2 === 'SYSTEM') {
        obj['element2@-' + item.id] = cascaderData[item.element2];
      }
    });

    form.setFieldsValue({
      ...obj,
    });
  }, [cascaderData, form, tabelD]);

  // 获取级联下拉数据
  const fetchPackageData = useCallback(() => {
    dispatch({
      type: 'bre/getAllPackages',
      payload: {},
      callback: (res) => {
        let result = [];
        let cascaderDataUnuse = {};
        console.log(res);
        res &&
          res.length > 0 &&
          res.forEach((item) => {
            let child = [];
            item.fields &&
              item.fields.forEach((item2) => {
                child.push({
                  // value: item2.id,
                  value: item2.id,
                  label: item2.fieldName,
                });
                cascaderDataUnuse[item2.id] = [item.fieldPackageId, item2.id];
              });
            result.push({
              value: item.fieldPackageId,
              label: item.fieldPackageName,
              children: child,
            });
          });
        setCascaderData(cascaderDataUnuse);
        setAddOptions(result);
      },
    });
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchPackageData();
  }, [fetchPackageData]);

  const handleCascaderChange = (val, record, i) => {
    tabelD.forEach((item) => {
      if (item.id === record.id) {
        item['element' + i] = val[1];
      }
    });
  };

  const columns = [
    {
      title: '组别',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      render: (text) => {
        return <span>{String(text).includes('null') ? '' : text}</span>;
      },
    },
    {
      title: '条件类型',
      dataIndex: 'variableType1',
      key: 'variableType1',
      width: 200,
      render: (text, record) => {
        let opt = toOption(tvfRuleTypeMap) || [];
        if (record.id === tabelD[0].id) {
          opt[1]['disabled'] = true;
        }
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'variableType1-' + record.id}
            value={text}
            option={opt}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
            onSelect={(val) => onSelectType(val, record, '1')}
          />
        );
      },
    },
    {
      title: '左条件',
      dataIndex: 'element1',
      key: 'element1',
      width: 200,
      render: (text, record) => {
        let opt = {};
        opt[record.element1] = record.element1Name;
        return record.variableType1 === 'TEMPORARY' ? (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            placeVal="请选择"
            name={'element1-' + record.id}
            // allowClear={true}
            className={['no_label']}
            option={toOption(groupOption(record.id))}
            value={record.element1Name ? '组别' + record.element1Name : ''}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
          />
        ) : (
          <div className={styles.seled_filter}>
            <Cascader
              height="37px"
              options={addOptions}
              allowClear={true}
              placeVal={'请输入'}
              name={'element1@-' + record.id}
              value={cascaderData[record.element1]}
              form={form}
              className={['mt']}
              require={[
                {
                  required: true,
                  message: '请选择规则包状态',
                },
              ]}
              onChange={(val) => handleCascaderChange(val, record, '1')}
              displayRender={(label) => {
                return String(editable) === 'false'
                  ? label && label[1]
                  : label.join('/');
              }}
            />
          </div>
        );
      },
    },
    {
      title: '运算符',
      dataIndex: 'operator',
      key: 'operator',
      width: 200,
      render: (text, record) => {
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'operator-' + record.id}
            // allowClear={true}
            option={toOption(tvfMathTypeMap)}
            value={text}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
          />
        );
      },
    },
    {
      title: '条件类型',
      dataIndex: 'variableType2',
      key: 'variableType2',
      width: 200,
      render: (text, record) => {
        let opt = toOption(tvfRuleTypeMap) || [];
        if (record.id === tabelD[0].id) {
          opt[1]['disabled'] = true;
        }
        return (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            className={['no_label']}
            placeVal="请选择"
            name={'variableType2-' + record.id}
            value={text}
            option={opt}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
            onSelect={(val) => onSelectType(val, record, '2')}
          />
        );
      },
    },
    {
      title: '右条件',
      dataIndex: 'element2',
      key: 'element2',
      width: 200,
      render: (text, record) => {
        let opt = {};
        opt[record.element2] = record.element2Name;
        return record.variableType2 === 'TEMPORARY' ? (
          <SelectML
            height="37px"
            labelwidth="130px"
            inputWidth="180px"
            placeVal="请选择"
            name={'element2-' + record.id}
            // allowClear={true}
            className={['no_label']}
            option={toOption(groupOption(record.id))}
            value={record.element2Name ? '组别' + record.element2Name : ''}
            require={[
              {
                required: true,
                message: '请选择规则包状态',
              },
            ]}
          />
        ) : (
          <div className={styles.seled_filter}>
            <Cascader
              height="37px"
              options={addOptions}
              allowClear={true}
              placeVal={'请输入'}
              name={'element2@-' + record.id}
              value={cascaderData[record.element2]}
              form={form}
              className={['mt']}
              require={[
                {
                  required: true,
                  message: '请选择规则包状态',
                },
              ]}
              onChange={(val) => handleCascaderChange(val, record, '2')}
              displayRender={(label) => {
                return String(editable) === 'false'
                  ? label && label[1]
                  : label.join('/');
              }}
            />
          </div>
        );
      },
    },
    {
      title: '操作',
      render: (record) => {
        return (
          <div className={styles.handle_btn}>
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => deleteRuleChange(record)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(editable) === 'false'}
            />
          </div>
        );
      },
      width: 100,
    },
  ];
  return (
    <Loading loading={delLoading || saveLoading}>
      <DataTable
        // bordered={true}
        className="demo-test"
        style={{ border: '1px solid #edf0f0' }}
        columns={columns}
        rowSelection={false}
        scroll={{
          x: 1547,
          y: 'calc(100vh - 160px - 3rem)',
        }}
        dataSource={tabelD}
        loading={loading}
        title={() => (
          <div className="rule_name">
            <span>临时变量名称</span>
            {name}
          </div>
        )}
        footer={() => (
          <ButtonML
            size="large"
            value="添加输入组"
            htmlType="submit"
            fontsize="16px"
            onClick={() => addRuleList()}
            disabled={String(editable) === 'false'}
          />
        )}
      />
      <ModalML
        title="新增"
        handleOk={trigger.open}
        handleCancel={trigger.close}
        visible={trigger.visible}
      >
        <AddFieldPackage
          handleCancel={trigger.close}
          changeOptions={changeOptions}
        />
      </ModalML>
    </Loading>
  );
};
export default RuleTabel;
